import {
  INIT_ORDER_HELP,
  SET_HELP_ORDER_ID,
  SET_SPECIFIC_HELP_PAGE,
  RESET_INTERACTION,
  RELOAD_INTERACTION,
  UPDATE_INTERACTION_REQUEST,
  UPDATE_INTERACTION_SUCCESS,
  UPDATE_INTERACTION_FAILURE,
  CLOSE_INTERACTION_DIALOG,
  SET_LIVE_CHAT_DEPARTMENT,
  SET_ORDER_HELP_MODAL_IS_OPEN,
  SET_ORDER_HELP_MODAL_PAGE,
} from '../../actions/types';

import { createInteractionTemplateData, createInteractionHistory } from './factories';

const initialState = {
  id: undefined,
  error: null,
  loading: false,
  orderHelpModal: {},
};

export default function helpReducer(state = initialState, action = {}) {
  const newAction = Object.assign({}, action);

  if (newAction.payload) {
    newAction.payload = Object.assign({}, newAction.payload);
  }
  const trackedActions = state.trackedActions ? state.trackedActions.slice(0) : [];

  switch (newAction.type) {
    case INIT_ORDER_HELP:
      return {
        ...state,
        // TODO: This is not great, it should ideally be more specific
        // to the keys that are allowed in this object (especially in lieu of types
        // helping us check we are doing The Right Thing)
        ...action.payload,
      };
    case SET_HELP_ORDER_ID:
      return {
        ...state,
        id: newAction.payload.orderId,
        orderHelpModal: {
          ...state.orderHelpModal,
          isOpen: false,
        },
      };
    case SET_SPECIFIC_HELP_PAGE:
      return {
        ...state,
        isSpecificHelpPage: newAction.payload.isSpecificHelpPage,
      };
    case RESET_INTERACTION:
      return {
        ...state,
        interactionId: null,
        type: null,
        subType: null,
        isFirstHelpPage: null,
        isHelpHome: false,
        showSelfHelpPreviousButton: null,
        actionId: null,
        title: null,
        header: null,
        showDialog: null,
        data: {},
        submissionTemplateData: null,
        interactionHistory: null,
      };
    case UPDATE_INTERACTION_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case UPDATE_INTERACTION_FAILURE:
      return {
        ...state,
        loading: false,
        type: 'empty_state',
        error: {
          statusCode: newAction.status,
          message: newAction.message,
        },
      };
    case UPDATE_INTERACTION_SUCCESS: {
      const templateData = newAction.payload.template;
      const interactionData = createInteractionTemplateData(state, templateData);

      return {
        ...state,
        error: null,
        loading: false,
        trackedActions,
        interactionId: newAction.payload.id || state.interactionId,
        ...interactionData,
        interactionHistory: {
          ...state.interactionHistory,
          ...createInteractionHistory(interactionData),
        },
      };
    }
    case RELOAD_INTERACTION:
      return {
        ...state,
        ...newAction.payload.interactionData,
      };
    case CLOSE_INTERACTION_DIALOG:
      return {
        ...state,
        showDialog: false,
      };
    case SET_LIVE_CHAT_DEPARTMENT: {
      return {
        ...state,
        data: {
          ...state.data,
          liveChat: {
            ...((state.data && state.data.liveChat) || {}),
            department: newAction.payload.department,
          },
        },
      };
    }
    case SET_ORDER_HELP_MODAL_IS_OPEN:
      return {
        ...state,
        orderHelpModal: {
          ...state.orderHelpModal,
          isOpen: newAction.payload.isOpen,
        },
      };
    case SET_ORDER_HELP_MODAL_PAGE:
      return {
        ...state,
        orderHelpModal: {
          ...state.orderHelpModal,
          selectedActionId: newAction.payload.selectedActionId,
          selectedActionTemplate: newAction.payload.selectedActionTemplate,
          actionId: newAction.payload.actionId,
          actionTemplate: newAction.payload.actionTemplate,
        },
      };

    default:
      return { ...state };
  }
}
